module.exports = __webpack_public_path__ + "img/img／邀请人.aded5ef9.png";